import React, { useState } from 'react';

export default function RegisterSectionSignUpLightReversePattern1() {
  const [form, setForm] = useState({
    full_name: '',
    email: '',
    password: '',
    confirmPassword: '',
    agreed: false,
    role: 'accountant', // default role
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === "checkbox" ? checked : value,
    }));
    setError('');
    setSuccess('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Basic validation
    if (!form.email || !form.password) {
      setError("Email and password are required.");
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    if (!form.agreed) {
      setError("You must agree to the Terms & Conditions.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000"}/register`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: form.email,
            password: form.password,
            full_name: form.full_name,
            role: form.role, // <-- send role to backend
          }),
        }
      );
      if (res.ok) {
        setShowConfirm(true);
        setSuccess("Registration successful! Please check your email and confirm your address before logging in.");
        setForm({
          full_name: '',
          email: '',
          password: '',
          confirmPassword: '',
          agreed: false,
          role: 'accountant',
        });
      } else {
        const data = await res.json();
        setError(data.detail || "Registration failed.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <section className="relative pb-24 bg-gray-100 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 min-w-max transform -translate-x-1/2 -translate-y-1/2">
          <div className="absolute bg-gradient-radial-gray w-full h-full" />
          <img src="zanrly-assets/images/pattern-white.png" alt="" />
        </div>
        <div className="container mx-auto px-4">
          <div className="relative mb-16 py-16 px-8 max-w-xl mx-auto bg-white rounded-b-3xl">
            <svg className="absolute top-0 -left-6" width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width={1440} height={992} transform="translate(-424)" fill="#F3F4F6" />
              <path fillRule="evenodd" clipRule="evenodd" d="M24 24C24 10.7452 13.2548 0 0 0H24H91H501H568H592C578.745 0 568 10.7452 568 24V162C568 175.255 557.255 186 544 186H48C34.7452 186 24 175.255 24 162V24Z" fill="white" />
            </svg>
            <svg className="absolute top-0 -right-6" width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width={1440} height={992} transform="translate(-992)" fill="#F3F4F6" />
              <path fillRule="evenodd" clipRule="evenodd" d="M-544 24C-544 10.7452 -554.745 0 -568 0H-544H-477H-67H0H24C10.7452 0 0 10.7452 0 24V162C0 175.255 -10.7452 186 -24 186H-520C-533.255 186 -544 175.255 -544 162V24Z" fill="white" />
            </svg>
            <img className="mx-auto" src="https://static.shuffle.dev/uploads/files/bd/bd9a85b8a4fa1ba404318e6dc3a1410c26c46d6a/FullLogo.png" alt="" />
          </div>
          <div className="relative md:max-w-md mx-auto">
            <div className="mb-10 text-center">
              <h2 className="font-heading mb-4 text-4xl md:text-5xl text-black font-black tracking-tight">Sign up here</h2>
              <p className="text-gray-500 font-bold">Register for an account</p>
            </div>
            {!showConfirm ? (
              <form onSubmit={handleSubmit}>
                <div className="flex flex-wrap -m-3">
                  {error && (
                    <div className="w-full p-3">
                      <div className="bg-red-100 text-red-700 px-4 py-2 rounded font-bold">{error}</div>
                    </div>
                  )}
                  {success && (
                    <div className="w-full p-3">
                      <div className="bg-green-100 text-green-700 px-4 py-2 rounded font-bold">{success}</div>
                    </div>
                  )}
                  <div className="w-full p-3">
                    <label className="block mb-2 text-sm text-gray-500 font-bold" htmlFor="signUpFullName">Full Name</label>
                    <input
                      className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-white placeholder-gray-500 outline-none border border-gray-200 focus:ring-4 focus:ring-blue-200 rounded-full"
                      id="signUpFullName"
                      type="text"
                      name="full_name"
                      placeholder="First and last name"
                      value={form.full_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="w-full p-3">
                    <label className="block mb-2 text-sm text-gray-500 font-bold" htmlFor="signUpEmail">Email Address</label>
                    <input
                      className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-white placeholder-gray-500 outline-none border border-gray-200 focus:ring-4 focus:ring-blue-200 rounded-full"
                      id="signUpEmail"
                      type="email"
                      name="email"
                      placeholder="Enter email address"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="w-full p-3">
                    <label className="block mb-2 text-sm text-gray-500 font-bold" htmlFor="signUpPassword">Password</label>
                    <input
                      className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-white placeholder-gray-500 outline-none border border-gray-200 focus:ring-4 focus:ring-blue-200 rounded-full"
                      id="signUpPassword"
                      type="password"
                      name="password"
                      placeholder="***************"
                      value={form.password}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="w-full p-3">
                    <label className="block mb-2 text-sm text-gray-500 font-bold" htmlFor="signUpConfirmPassword">Confirm Password</label>
                    <input
                      className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-white placeholder-gray-500 outline-none border border-gray-200 focus:ring-4 focus:ring-blue-200 rounded-full"
                      id="signUpConfirmPassword"
                      type="password"
                      name="confirmPassword"
                      placeholder="***************"
                      value={form.confirmPassword}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* Role Dropdown */}
                  <div className="w-full p-3">
                    <label className="block mb-2 text-sm text-gray-500 font-bold" htmlFor="signUpRole">Role</label>
                    <select
                      id="signUpRole"
                      name="role"
                      className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-white border border-gray-200 rounded-full"
                      value={form.role}
                      onChange={handleChange}
                      required
                    >
                      <option value="accountant">Accountant</option>
                      <option value="staff">Staff</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                  <div className="w-full p-3">
                    <div className="flex flex-wrap items-center justify-between -m-3">
                      <div className="w-auto p-3">
                        <div className="flex items-center">
                          <input
                            className="opacity-0 absolute h-6 w-6"
                            id="signUpTOS"
                            type="checkbox"
                            name="agreed"
                            checked={form.agreed}
                            onChange={handleChange}
                          />
                          <div className="flex flex-shrink-0 justify-center items-center w-6 h-6 mr-4 text-transparent bg-white border border-gray-200 border-neutral-200 rounded-md">
                            <svg width={9} height={7} viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0.603516 3.77075L2.68685 5.85409L7.89518 0.645752" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                          <label className="text-gray-500 font-bold" htmlFor="signUpTOS">
                            <span>By signing up, I agree to the </span>
                            <a className="text-blue-500 hover:text-blue-600" href="#">Terms &amp; Conditions</a>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full p-3">
                    <div className="flex flex-wrap md:justify-end -m-2">
                      <div className="w-full p-2">
                        <button
                          className="block w-full px-8 py-3.5 text-lg text-center text-white font-bold bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 rounded-full"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Registering..." : "Sign Up"}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="w-full p-3">
                    <p className="text-gray-500 text-center font-bold">
                      <span>Already have an account? </span>
                      <a className="text-blue-500 hover:text-blue-600 font-bold" href="/login">
                        Sign In
                      </a>
                    </p>
                  </div>
                </div>
              </form>
            ) : (
              <div className="bg-green-100 text-green-700 p-6 rounded-lg shadow-md text-center font-bold text-xl">
                Registration successful!<br />
                Please check your email and confirm your address before logging in.
              </div>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
